import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';

export class CfFaqWidget {
    static contentType = contentTypes.CfFaqWidget;

    constructor(entity) {
        const { fields } = entity;
        const { title, description } = fields || {};

        Object.assign(this, {
            title,
            description,
        });
    }
}
